module.exports = __webpack_public_path__ + "img/tr-transmission.f063e925.gif";